import React, { useEffect, useState, useCallback } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import SearchIcon from '../../../assets/icons/table/search.svg';
import playlistBold from "../../../assets/icons/signage-plus/playlist-bold.svg";
import API from '../../../utils/API';
import { SIGNAGE_MEDIA } from '../../../utils/constants';

const AddPlaylist = ({
  setError,
  closeModal,
  zone,
  setZone,
  playlistData,
  setZoneData,
  markUnsavedChanges
}) => {

  const [playlists, setPlaylists] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [playlistName, setPlaylistName] = useState('');
  const [playlistId, setPlaylistId] = useState('');
  const [modalError, setModalError] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const intl = useIntl();
  const t = (id) => intl.formatMessage({ id });

  /**
    * Reset modal
    */
  function resetModal() {
    setZone('');
  }

  useEffect(() => {
    const modalElement = document.getElementById('addPlaylistModal');
    modalElement.addEventListener('hidden.bs.modal', resetModal);

    return () => {
      modalElement.removeEventListener('hidden.bs.modal', resetModal);
    };
  }, []);

  useEffect(() => {
    if (zone !== SIGNAGE_MEDIA.CREATE_SIGNAGE.PLAYLIST) return;
    if (playlistData) {
      setPlaylistId(playlistData.playlistId || '');
    }
  }, [playlistData, zone]);

  useEffect(() => {
    const fetchPlaylists = async () => {
      const res = await API.getPlaylists()
      setPlaylists(res.data);
    }
    fetchPlaylists();
  }, []);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
  };

  const handleAdd = async () => {
    try {
      if (playlistId) {
        setZoneData((prevZoneData) => {
          const newZoneData = { ...prevZoneData };
          newZoneData[zone] = {
            zone: zone,
            playlistId: playlistId,
          };
          return newZoneData;
        });
        markUnsavedChanges && markUnsavedChanges();
      } else {
        setError(<FormattedMessage id="SELECT_PLAYLIST" />)
        return;
      }
      closeModal("addPlaylistModal");
    } catch (err) {
      setError(<FormattedMessage id="ADD_PLAYLIST_FAILED" values={{ errorMsg: <b>{err.message}</b> }} />);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);

    if (playlistId) {
      handleAdd();
    } else {
      setError(<FormattedMessage id="SELECT_PLAYLIST" />);
    }
  };

  const filteredPlaylists = playlists.filter(item =>
    item.name.toLowerCase().includes(searchTerm.trim().toLowerCase())
  );

  return (
    <div className='modal modal-mse fade' id='addPlaylistModal' tabIndex='-1' aria-labelledby='addPlaylistModalLabel' aria-hidden='true'>
      <div className='modal-dialog modal-dialog-centered'>
        <div className='modal-content modal-mes-content'>
          <div className='modal-header modal-mes-header' style={{ backgroundColor: '#347BFA' }}>
            <h5 className='modal-title modal-mes-title'><FormattedMessage id='ADD_PLAYLIST' /></h5>
            <button id="closeModal" type='button' className='btn-close' data-bs-dismiss='modal' aria-label='Close'></button>
          </div>
          <div className='modal-body' style={{ padding: '0px' }}>
            <div className='row' style={{ backgroundColor: 'rgba(233, 243, 252, 1)', padding: '15px' }}>
              <div id="search" className="form-outline search-container h-100 ms-auto position-relative" style={{ height: 'auto', width: '100%' }}>
                <input
                  id="searchInput"
                  className="form-control"
                  type="search"
                  placeholder={t("SEARCH")}
                  value={searchTerm}
                  onChange={handleSearchChange}
                />
                <img src={SearchIcon} className="searchIcon position-absolute" alt="Search Icon" style={{ top: '20px' }} />
              </div>
            </div>
            <ul className="list-group flex-scroll">
              {filteredPlaylists.map((item) => (
                <li
                  className="list-group-item d-flex align-items-center justify-content-between"
                  style={{
                    height: '64px',
                    background: playlistId === item.id ? 'rgba(52, 123, 250, 0.15)' : undefined,
                    borderStyle: playlistId === item.id ? 'solid' : undefined,
                    borderWidth: playlistId === item.id ? '2px 0px 2px 0px' : undefined,
                    borderColor: playlistId === item.id ? 'rgba(52, 123, 250, 1)' : undefined,
                    cursor: 'pointer'
                  }}
                  key={item.id}
                  onClick={() => {
                    setPlaylistId(item.id)
                  }}
                >
                  <div className="d-flex align-items-center">
                    <img src={playlistBold} alt="" className="icon icon-24 me-3" />
                    <span >{item.name}</span>
                  </div>
                </li>
              ))}
            </ul>
          </div>
          <div className='modal-footer modal-mes-footer d-flex align-items-center'>
            <button id="backGroupModalBtn" type='button' className='btn btn-outline-secondary me-3' data-bs-dismiss='modal'>
              <FormattedMessage id='CANCEL' />
            </button>
            <button id="saveGroupBtn" className='btn btn-primary but-darkblue' type='button' onClick={handleSubmit}>
              <FormattedMessage id='ADD_PLAYLIST' />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddPlaylist;
